export enum EfiModules {
    Gen = "gen",
    Vam = "vam",
}

export interface UserModule {
    mod: EfiModules;
}

export interface User {
    id: number;
    cdCliente: number;
    cdCompania: number;
    usuario: string;
    clave: string;
    activo: boolean;
    email: string;
    fcCreacion: string;
    fcCambioClave: string;
    intentosFallidos: number;
    fcIntentoFallido?: Date;
    contadorSesiones: number;
    fcUltVisita?: Date;
    fcUltVisitaTmp?: Date;
    fcModifica: string;
    rolWeb: string;
    cdEjecutivoAdm?: number;
    cdSucEjeAdm?: number;
    cdPool?: number;
    cdPersAdm?: number;
    tpPersAdm?: string;
    cdEjecutivo?: number;
    cdSucPersAdm?: number;
    cdSucursalEje?: number;
    cedula: string;
    nmAsegurado: string;
    apAsegurado: string;
    observaciones?: string;
    tipoUsuario: string;
    usrcod: string;
    enviarEmail: boolean;
    rolCotizador: string;
    rolCotizadorVam: string;
    uuid: string;
    asociados: Contractor[];
    asociadosVam: Insued[];
    roles: string[];
    isAdmin: boolean;
    isBroker: boolean;
    isEjecutivo: boolean;
    isSubAgente: boolean;
    isCotizador: boolean;
    isCotizadorAdmin: boolean;
    isCotizadorVam: boolean;
    isCotizadorVamAdmin: boolean;
    isUser: boolean;
    isEfiUser: boolean;
    isModuleGen: boolean;
    isModuleVam: boolean;
    moduleName?: string;
    fullName: string;
    adminReportes: boolean;
    adminTOTP: boolean;
}

export interface Member {
    cdCompania: number;
    cdAdicional: number;
    cedula: string;
    fcCreacion: string;
    usuarioWeb: string;
    activo: boolean;
    uuid: string;
    activeCard: boolean;
    anyRecentPolicy: boolean;
}

export interface Contractor extends Member {
    cdCliContac: number;
    cdEjecutivo: number;
    cdCliente: number;
    nmAsegurado: string;
    apAsegurado: string;
    nmEjecutivo: string;
    apEjecutivo: string;
    tpPersona: number;
}

export interface Insued extends Member {
    cdCliVam: number;
    nmCliente: string;
    apCliente: string;
}
